import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var generateStyle = function generateStyle(componentTheme, props) {
  var correctRowBorderStyles = {
    borderColor: componentTheme.colorGreen,
    borderWidth: '2px 0',
    borderStyle: 'solid',
    padding: componentTheme.cellPadding
  };
  return {
    iconWrapper: _objectSpread({
      display: 'flex',
      height: '48px',
      width: '46px',
      justifyContent: 'center',
      alignItems: 'center'
    }, props.choice.correct && {
      backgroundColor: componentTheme.colorGreen,
      borderRadius: '4px 0 0 4px',
      svg: {
        fill: 'white'
      }
    }),
    correctRowBorder: _objectSpread({
      borderWidth: '0'
    }, props.choice.correct && correctRowBorderStyles),
    correctRowBorderRadius: {
      borderWidth: '2px 2px 2px 0',
      borderRadius: '0 4px 4px 0'
    },
    lastRowBorder: _objectSpread({
      borderWidth: '0'
    }, props.choice.correct && _objectSpread(_objectSpread({}, correctRowBorderStyles), {}, {
      borderWidth: '2px 2px 2px 0',
      borderRadius: '0 4px 4px 0'
    })),
    cellPadding: componentTheme.cellPadding
  };
};
export default generateStyle;